import { TSelectOpt } from 'transfix-ui/components/Select/SelectTypes'
import { IShipmentStopAppointmentTypes } from 'types/graphqlTypes'

export const APPOINTMENT_TYPE_OPTIONS: TSelectOpt[] = [
  {
    label: 'Appt.',
    value: IShipmentStopAppointmentTypes.appointment,
  },
  {
    label: 'FCFS',
    value: IShipmentStopAppointmentTypes.range,
  },
]
